module.exports = __webpack_public_path__ + "static/haus_4k-1bfbeb69d4961b5f0fe72483c34ae2f9.jpg";